import { render, staticRenderFns } from "./ReviewYourAnswersAPS.vue?vue&type=template&id=de42dc04"
import script from "./ReviewYourAnswersAPS.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersAPS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports